const NewHireEditorActionTypes = {
  GET_NEW_HIRE_EDITOR_DATA_START: 'GET_NEW_HIRE_EDITOR_DATA_START',
  GET_NEW_HIRE_EDITOR_DATA_SUCCESS: 'GET_NEW_HIRE_EDITOR_DATA_SUCCESS',
  GET_NEW_HIRE_EDITOR_DATA_FAILURE: 'GET_NEW_HIRE_EDITOR_DATA_FAILURE',

  SET_NEW_HIRE_EDITOR_POSITIONS: 'SET_NEW_HIRE_EDITOR_POSITIONS',
  SET_NEW_HIRE_EDITOR_DEPARTMENTS: 'SET_NEW_HIRE_EDITOR_DEPARTMENTS',

  SET_NEW_HIRE_EDITOR_DEPARTMENT: 'SET_NEW_HIRE_EDITOR_DEPARTMENT',
  SET_NEW_HIRE_EDITOR_POSITION: 'SET_NEW_HIRE_EDITOR_POSITION',

  SET_NEW_HIRE_EDITOR_LOCAL_DISTROS: 'SET_NEW_HIRE_EDITOR_LOCAL_DISTROS',

  SET_NEW_HIRE_EDITOR_AZURE_GROUPS: 'SET_NEW_HIRE_EDITOR_AZURE_GROUPS',
  SET_NEW_HIRE_EDITOR_GOOGLE_GROUPS: 'SET_NEW_HIRE_EDITOR_GOOGLE_GROUPS',

  SET_NEW_HIRE_EDITOR_NOC: 'SET_NEW_HIRE_EDITOR_NOC',
  SET_NEW_HIRE_EDITOR_NAVITAIRE: 'SET_NEW_HIRE_EDITOR_NAVITAIRE',
  SET_NEW_HIRE_EDITOR_UBER: 'SET_NEW_HIRE_EDITOR_UBER',
  SET_NEW_HIRE_EDITOR_LYFT: 'SET_NEW_HIRE_EDITOR_LYFT',
};

export default NewHireEditorActionTypes;
